import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { CollectionPreviewTooltipFragment } from "@/components/collection/CollectionPreviewTooltip/CollectionPreviewTooltip.fragment"
import { CollectionLinkFragment } from "@/components/items/collection/CollectionLink.fragment"
import { ItemLinkFragment } from "@/components/items/ItemLink"
import { useBuyItemsFragment } from "@/components/items/use-buy-items.fragment"
import { ItemRewardMediaFragment } from "../TreasureChestShareView/ItemRewardMedia.fragment"
import { GrandPrizeModalFragment } from "./GrandPrizeModal.fragment"

export const ItemRewardCardFragment = graphql(
  `
    fragment ItemRewardCard on UserReward {
      id
      address
      claimedAt
      orderId
      isGrandPrize
      ...ItemRewardMedia
      ...GrandPrizeModal
      item {
        id
        name
        imageUrl
        ...ItemLink
        collection {
          ...CollectionLockup
          ...CollectionLink
          ...CollectionPreviewTooltip
          name
          imageUrl
        }
        ...useBuyItems
      }
    }
  `,
  [
    CollectionLockupFragment,
    useBuyItemsFragment,
    ItemLinkFragment,
    CollectionLinkFragment,
    CollectionPreviewTooltipFragment,
    ItemRewardMediaFragment,
    GrandPrizeModalFragment,
  ],
)
